/**
 * Format currency values as UK pounds (£)
 * @param {number|string} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, decimals = 2) => {
  if (value === null || value === undefined || value === '') return '-';
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) return '-';
  
  return `£${numValue.toLocaleString('en-GB', { 
    minimumFractionDigits: decimals, 
    maximumFractionDigits: decimals 
  })}`;
};

/**
 * Format currency without decimals
 * @param {number|string} value - The value to format
 * @returns {string} Formatted currency string without decimals
 */
export const formatCurrencyWhole = (value) => {
  return formatCurrency(value, 0);
};
